import { ReactNode } from 'react';
import styles from './ContextSection.module.css';

interface ContextSectionProps {
  title: string;
  children: ReactNode;
}

export default function ContextSection({
  title,
  children,
}: ContextSectionProps) {
  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <div className={styles.accentBar} />
        <span className={styles.title}>{title}</span>
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
